export function lessThanEqualMatcherContext(ruleAttr) {
    return function lessThanEqualMatcher(runtimeAttr) {
        var isLessThanEqual = runtimeAttr <= ruleAttr;
        return isLessThanEqual;
    };
}
